/** @jsx h */

import {h, render} from "preact";
import Select, {
    components,
    MultiValueGenericProps,
    MultiValueProps,
    OnChangeValue,
    Props,} from 'react-select';
import {useState} from "preact/hooks";
import {onFind} from "@elements/init-modules-in-scope";
import {getPrefixedDataSet} from "@elements/data-set-utils";
import {
    SortableContainer,
    SortableContainerProps,
    SortableElement,
    SortEndHandler,
    SortableHandle,
} from 'react-sortable-hoc'

const defaultSelectors = {
    base: '.js-sortable-react-select'
};

const defaultOptions = {
    selectAll: 'select all',
    removeAll: 'remove all',
    placeholder: 'select...',
    name: 'filter[]'
};

export function init(options = defaultOptions, selectors = defaultSelectors) {
    onFind(selectors.base, (base) => {
        let options = {
            ...defaultOptions,
            ...getPrefixedDataSet('sortable-react-select', base)
        }
        console.log(options);

        render(<MultiSelectSort
            options={ JSON.parse(options.options)}
            selectAllTranslation={options.selectAll}
            removeAllTranslation={options.removeAll}
            name={options.name}
            placeholder={options.placeholder} />, base) });
}

function arrayMove(array, from, to) {
    const slicedArray = array.slice();
    slicedArray.splice(
        to < 0 ? array.length + to : to,
        0,
        slicedArray.splice(from, 1)[0]
    );
    return slicedArray;
}

const SortableMultiValue = SortableElement(
    props => {
        return <components.MultiValue {...props} />;
    }
);

const SortableMultiValueLabel = SortableHandle(
    props => {
        const onMouseOver = (e) => {
            e.target.style.cursor = 'grab';
        }
        const onMouseDown = (e) => {
            e.target.style.cursor = 'grabbing';
        }
        const onMouseUp = (e) => {
            e.target.style.cursor = 'grab';
        }
        const innerProps = {...props.innerProps, onMouseOver, onMouseDown, onMouseUp}
        return <components.MultiValueLabel {...props} innerProps={innerProps} />
    }
);

const SortableSelect = SortableContainer(Select);

export default function MultiSelectSort(
    {
        options = [],
        selectAllTranslation = "",
        removeAllTranslation = "",
        placeholder = "",
        name = ""
    }) {

    const [selected, setSelected] = useState([]);

    const onChange = (selectedOptions) => {
        if(selectedOptions.find(option => option.value === "all")){
            if(selected.length === options.length){
                setSelected([]);
            }else{
                setSelected(options);
            }
        }else{
            setSelected(selectedOptions);
        }
    }
        

    const onSortEnd = ({ oldIndex, newIndex }) => {
        const newValue = arrayMove(selected, oldIndex, newIndex);
        setSelected(newValue);
        console.log(
            'Values sorted:',
            newValue.map((i) => i.value)
        );
    };

    return (
        <SortableSelect
            useDragHandle
            // react-sortable-hoc props:
            axis="xy"
            onSortEnd={onSortEnd}
            distance={4}
            // small fix for https://github.com/clauderic/react-sortable-hoc/pull/352:
            getHelperDimensions={({ node }) => node.getBoundingClientRect()}
            // react-select props:
            isMulti
            options={[{label: selected.length === options.length ? removeAllTranslation : selectAllTranslation, value: 'all'}, ...options]}
            value={selected}
            onChange={onChange}
            className={"sortable-react-select"}
            components={{
                MultiValue: SortableMultiValue,
                MultiValueLabel: SortableMultiValueLabel,
            }}
            placeholder={placeholder}
            label={'Label'}
            closeMenuOnSelect={false}
            name={name}
        />
    );
}